"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nft_uri_to_url = void 0;
const defs_1 = require("./defs");
function nft_uri_to_url(uri) {
    // extract CID from uri
    const regex = /ipfs:\/\/(.+)/;
    const match = uri.match(regex);
    if (!(match && match[1])) {
        throw new Error("nft metadata uri must start with ipfs://");
    }
    return `https://${defs_1.IPFS_HTTP_GATEWAY}/ipfs/${match[1]}`;
}
exports.nft_uri_to_url = nft_uri_to_url;
